import emergencyBox1Plugin from './emergencyBox1Plugin';
import emergencyBox2Plugin from './emergencyBox2Plugin';

const emergencyScreenLayoutPlugin: any = {
  Renderer: ({ children, data }: any) => (
    <div className="emergency-screen-layout" style={{ padding: 10 }}>
      {children}
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: emergencyBox2Plugin,
        },
        {
          plugin: emergencyBox1Plugin,
        },
        {
          plugin: emergencyBox1Plugin,
        },
        {
          plugin: emergencyBox1Plugin,
        },
      ],
    ];
  },

  id: 'emergency-screen-layout-plugin',
  title: 'Screen Layout',
  // description: 'emergency content plugin',
  version: 1,
  // controls: {
  //   type: 'autoform',
  //   schema: {
  //     required: ['backgroundColor'],
  //     properties: {
  //       backgroundColor: { type: 'string' },
  //     },
  //   },
  // },
};

export default emergencyScreenLayoutPlugin;
